
<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    deleteTitle="Deleção de ..."
    :formErrors="formErrors"
    ref="baseDelete"
  >
    <p> Você tem certeza que deseja deletar este ...?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@components/shared/base_delete.vue";

export default {
  data () {
    return {
      error: null,
      loading: true,
      formErrors: []
    }
  },
  components: {
    BaseDelete: BaseDelete
  },
  props: {
    entry: Object,
  },
  methods: {
    destroyServerEntry: function(item_weight) {
      this.loading = true;
        this.$apollo
          .mutate({
            mutation: DESTROY_ITEM_WEIGHT_MUTATION,
            variables: {
              id: item_weight.id,
            }
          })
          .then(response => {
            var errors = response.data.destroyItemWeight.errors
            if (errors.length){
              this.formErrors = errors
            } else {
              this.$emit("entry-destroyed");
              this.$refs.baseDelete.closeDialog();
            }
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
    },
    destroyEntry: function() {
      this.destroyServerEntry(this.entry);
    },
  }
}
const DESTROY_ITEM_WEIGHT_MUTATION = gql `
  mutation($id: ID!) {
    destroyItemWeight(id: $id) {
      item_weight {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>

